"use client";

import React from "react";
import { MapPin, Phone, Mail, ExternalLink } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-32 bg-muted/10 animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        {[{
        label: "Notarías",
        href: "/HomePage"
      }, {
        label: "Inmobiliarias",
        href: "/HomePage"
      }, {
        label: "Desarrolladoras",
        href: "/HomePage"
      }, {
        label: "Casas de Empeño",
        href: "/HomePage"
      }].map((item, i) => <li key={i} data-index={i}>
            <Link to={item.href} className="text-muted-foreground hover:text-primary transition-colors duration-200 text-sm font-default">
              {item.label}
            </Link>
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors duration-200 text-sm font-default">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function PieDePGina() {
  const currentYear = new Date().getFullYear();
  return <section data-section-id="265078" id="pie-de-página" className="bg-background text-foreground">
      <div className="bg-card text-foreground pt-16 pb-8 border-t border-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-12">
            {}
            <div className="flex flex-col gap-6">
              <Link to="/" className="inline-block w-fit">
                <WvcLogo className="h-8 w-auto text-primary" />
              </Link>
              <p className="text-muted-foreground text-sm font-default leading-relaxed max-w-xs">
                Plataforma PLD/AML para sujetos obligados del Art. 17 LFPIORPI. Cumplimiento normativo simplificado y expedientes auditables.
              </p>
            </div>

            {}
            <div className="flex flex-col gap-6">
              <h3 className="text-lg font-default font-semibold text-foreground">
                Sectores
              </h3>
              <MenuProvider menu_id="17">
                <FooterMenuConsumer />
              </MenuProvider>
            </div>

            {}
            <div className="flex flex-col gap-6">
              <h3 className="text-lg font-default font-semibold text-foreground">
                Recursos
              </h3>
              <div className="flex flex-col gap-4">
                <div className="flex flex-col gap-3">
                  <Link to="/GuideLFPIORPIPage" className="text-sm font-default text-muted-foreground hover:text-primary transition-colors">
                    Guía LFPIORPI
                  </Link>
                  <Link to="/PricingPage" className="text-sm font-default text-muted-foreground hover:text-primary transition-colors">
                    Planes y Precios
                  </Link>
                  <Link to="#" className="text-sm font-default text-muted-foreground hover:text-primary transition-colors">
                    Actividades Vulnerables
                  </Link>
                </div>
                <Link to="/GuideLFPIORPIPage" className="inline-flex items-center gap-2 text-sm font-default font-medium text-primary hover:text-primary/80 transition-colors w-fit">
                  Reforma 2025
                  <ExternalLink className="w-4 h-4" />
                </Link>
              </div>
            </div>

            {}
            <div className="flex flex-col gap-6">
              <h3 className="text-lg font-default font-semibold text-foreground">
                Legal
              </h3>
              <div className="flex flex-col gap-4">
                <Link to="#" className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors group w-fit">
                  <span className="text-sm font-mono">Art. 17 LFPIORPI</span>
                </Link>
                <Link to="mailto:contacto@notalia.mx" className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors group w-fit">
                  <Mail className="w-5 h-5 shrink-0 group-hover:scale-110 transition-transform" />
                  <span className="text-sm font-default">contacto@notalia.mx</span>
                </Link>
              </div>
            </div>
          </div>

          {}
          <div className="pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-muted-foreground text-[12px] font-mono text-center md:text-left uppercase tracking-wider">
              © {currentYear} NOTALIA. HECHO EN MÉXICO.
            </p>
            <div className="flex items-center gap-6">
              <Link to="#" className="text-muted-foreground hover:text-primary text-[12px] font-mono transition-colors uppercase">
                Privacidad
              </Link>
              <Link to="#" className="text-muted-foreground hover:text-primary text-[12px] font-mono transition-colors uppercase">
                Términos
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}